export function AddToWatch() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="58"
      viewBox="0 0 160 58"
      fill="none"
    >
      <g filter="url(#filter0_d_1957_7007)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.49805 13.6227C4.65233 13.6858 4.80683 13.752 4.96147 13.8218C5.9351 14.2584 7.25499 15.0679 7.67714 16.0234C7.28913 14.1408 6.56405 12.5385 5.15563 11.2565C6.11574 12.0754 7.37381 12.6503 8.64033 13.2291C10.3789 14.0236 12.1334 14.8253 13.155 16.2757C13.5456 16.8358 13.7672 17.3589 13.7926 17.9725C13.8641 14.93 13.1038 10.0709 11.0033 7.85445C12.702 8.65491 13.9913 9.94284 14.5839 11.6288C14.7421 10.1463 14.2259 8.89411 13.6991 7.61611C13.3817 6.846 13.0604 6.06652 12.8804 5.22162C14.432 6.31996 16.2893 6.54621 17.9787 5.96587C16.4525 6.15971 15.7077 5.31644 15.1481 4H147.392C146.772 4.34608 146.161 4.73577 145.547 5.12669C143.766 6.26131 141.969 7.40633 139.915 7.52581C139.124 7.56833 138.465 7.47827 137.822 7.15989C140.898 8.91759 146.298 10.9318 149.737 10.2601C147.972 11.3553 145.935 11.8079 143.879 11.4073C145.309 12.3756 146.879 12.6042 148.481 12.8376C149.446 12.9782 150.423 13.1205 151.389 13.4274C149.4 14.2234 148.135 15.7818 147.79 17.6369C148.722 15.5002 150.94 16.0005 153.723 16.6282L153.724 16.6282C154.447 16.7914 155.209 16.9631 155.996 17.0994V38.6527C155.047 38.6184 154.067 38.5422 153.054 38.3633C151.775 38.1407 149.969 37.5852 149.16 36.596C150.236 38.6754 151.613 40.3291 153.679 41.4091C152.289 40.737 150.632 40.4368 148.965 40.1345C146.676 39.7196 144.366 39.301 142.694 37.9113C142.053 37.3734 141.622 36.8292 141.388 36.1217C142.315 39.6874 144.812 45.1251 147.995 47.0903C145.75 46.6568 143.821 45.535 142.571 43.7449C142.879 45.5185 143.895 46.8258 144.933 48.1599C145.558 48.9639 146.191 49.7776 146.681 50.7091C144.509 49.8853 142.27 50.1673 140.495 51.3397C142.606 50.5092 143.857 51.8605 145.198 53.8382H15.7407C14.4249 53.3053 12.9238 53.2756 11.4651 53.8382H11.4254C11.8279 53.0499 12.3503 52.3576 12.8664 51.6736C13.73 50.5293 14.5761 49.408 14.8142 47.899C13.7765 49.4328 12.1534 50.4071 10.2537 50.8009C12.9297 49.0963 14.9793 44.452 15.7191 41.4148C15.5303 42.0179 15.171 42.4849 14.634 42.9488C13.2333 44.1475 11.2779 44.5294 9.34031 44.9078C7.92879 45.1835 6.52669 45.4574 5.35533 46.0438C7.09515 45.1034 8.24192 43.6839 9.12881 41.9066C8.45511 42.7555 6.92909 43.2477 5.84622 43.4513C5.38925 43.5384 4.9399 43.6007 4.49805 43.6459V13.6227ZM14.8103 47.894L14.8077 47.9028C14.8077 47.9028 14.8137 47.8995 14.815 47.8951L14.8103 47.894ZM143.876 11.4001L143.885 11.4048C143.885 11.4048 143.883 11.4055 143.88 11.4055C143.878 11.4054 143.876 11.4052 143.874 11.4042L143.876 11.4001ZM142.577 43.7392L142.58 43.7497C142.58 43.7497 142.577 43.7482 142.575 43.7459C142.573 43.7444 142.572 43.7425 142.571 43.7405L142.577 43.7392ZM14.5773 11.6323L14.5771 11.6233C14.5771 11.6233 14.582 11.6279 14.5821 11.6324L14.5773 11.6323Z"
          fill="#363636"
        />
      </g>
      <foreignObject x="0" y="0" width="100%" height="100%">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          className="flex items-center justify-center"
          style={{
            textAlign: 'center',
            color: '#fff',
            fontSize: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >

          {/* Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="22"
            viewBox="0 0 17 22"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.26367 0.00390745C1.51293 0.0039076 0.0937539 1.42313 0.0937541 3.17383L0.0937556 20.0801C0.0937556 20.4568 0.294306 20.8049 0.620069 20.994C0.945831 21.183 1.34756 21.1844 1.67459 20.9975L8.54688 17.0706L15.4191 20.9975C15.7462 21.1844 16.1479 21.183 16.4737 20.994C16.7995 20.8049 17 20.4568 17 20.0801L17 3.17383C17 1.42313 15.5808 0.00390637 13.8301 0.00390653L3.26367 0.00390745ZM12.7734 8.45703C12.7734 7.87347 12.3004 7.40039 11.7168 7.40039L9.60352 7.40039L9.60352 5.28711C9.60352 4.70355 9.13046 4.23047 8.54688 4.23047C7.96329 4.23047 7.49024 4.70355 7.49024 5.28711L7.49024 7.40039L5.37696 7.40039C4.79337 7.40039 4.32032 7.87347 4.32032 8.45703C4.32032 9.04061 4.79337 9.51367 5.37696 9.51367L7.49024 9.51367L7.49024 11.627C7.49024 12.2105 7.9633 12.6836 8.54688 12.6836C9.13046 12.6836 9.60352 12.2105 9.60352 11.627L9.60352 9.51367L11.7168 9.51367C12.3004 9.51367 12.7734 9.04061 12.7734 8.45703Z"
              fill="#F0ED9C"
            />
          </svg>
          <p
            style={{
              margin: '0 10px',
              fontSize: '16px',
              color: '#F0ED9C',
            }}
          >
            הוספה לרשימה
          </p>
        </div>
      </foreignObject>
      <defs>
        <filter
          id="filter0_d_1957_7007"
          x="0.798047"
          y="0.3"
          width="158.898"
          height="57.2379"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.85" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1957_7007"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1957_7007"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    )
}